var uAjax = "/index.cfm/customer/ajax/register";

$(function()
{
	initGender();

	//Code to show the VAT number if needed on page load B2C
	if($('#inputCompanyFieldIdB2C').length > 0){
		hideOrShowB2C();
	}

	//Code to show the VAT number if needed on page load B2B
	if($('#inputCompanyFieldIdB2B').length > 0){
		hideOrShowB2B();
	}

	$('#btnRegister').click(function(){
		var frmRegister = $('#frmRegister');

		if (typeof bNeedConfirmation == 'undefined') bNeedConfirmation = false;

		validateRegister(frmRegister,bNeedConfirmation);
		return false;
	});

	$('#frmRegister #inputEmail').blur(function(){

		var frmRegister = $('#frmRegister');
		validateEmail(frmRegister);
		return false;
	});

	$('#frmRegister').on('keyup','#inputEmail',function(){
		if($('#frmRegister #inputEmail').closest('.control-group').hasClass('error')){
			$('#frmRegister #inputEmail').closest('.control-group').removeClass('error');
			var frmRegister = $('#frmRegister');
			validateEmail(frmRegister);
		}
	});


	$(el('btnMailRegistrationData')).click(function(){
		var frmRegister = $('#frmRegister');
		mailRegistrationData(frmRegister);
		return false;
	});

	$('input[name^=inputGender]').change(function(){
		switchGender($(this));
	});

	$('#inputBirthday').on('focus',function(){
		$(this).val($(this).val());
	});

	$('.inputFirstName, .inputLastName, .inputCompany').on('change keyup', function(){
		toggleNameOrCompanyRequired();
	});

	//init
	if($('.crossGenderTitles').length)
	{
		setGenderFromTitles();
	}

	$('.register').on('change','.crossGenderTitles', function()
	{
		setGenderFromTitles();
	});

	if($('.inputVat').length && $('.inputVat').prop('required'))
	{
		setVatLanguageCode();
	}
	$('.register').on('change','select[name=inputCountry]', function()
	{
		if($('.inputVat').length && $('.inputVat').prop('required'))
		{
			setVatLanguageCode();
		}
	});

	$(el('imCustomer')).click(function(oEvent)
	{
		$('.inputNeedInvoice').bootstrapToggle('off');

	});

	$(el('imCompany')).click(function(oEvent)
	{
		$('.inputNeedInvoice').bootstrapToggle('on');
	});

	$('.inputNeedInvoice').change(function() {
		if($('.inputNeedInvoice').is(':checked')){
	    	$(el('imCompany')).removeClass('btn-default').addClass('btn-success');
	    	$(el('imCustomer')).addClass('btn-default').removeClass('btn-success');
	    }
	    else{
	    	$(el('imCustomer')).removeClass('btn-default').addClass('btn-success');
	    	$(el('imCompany')).addClass('btn-default').removeClass('btn-success');
	    }
    });

	$('.register').on('change','.noVat', function()
	{
		if($('.noVat').is(':checked')){
			$('.inputVatParent').hide();
		}
		else{
			$('.inputVatParent').show();
		}
	});

	if($('#inputPasswordCheck').parents('.inputPasswordContainer').length == 0)
	{
		var sMarginBottom = $(el('inputPasswordCheck')).css("marginBottom");
		$(el('inputPasswordCheck')).wrap('<div class="inputPasswordContainer"></div>');
		$(el('inputPasswordCheck')).css("marginBottom", '0');
		$('#inputPasswordCheck').parents('.inputPasswordContainer').css("marginBottom",sMarginBottom);
	}

	initDropzone();
});

function setGenderFromTitles()
{
	var genderId = $('.crossGenderTitles').find(":selected").data('column');
	switchGenderFromTitle(genderId);
}

function setVatLanguageCode()
{
	oInputVat = $('.inputVat');
	if(oInputVat.val().length <= 2){
		var sLanguageCode = $('select[name=inputCountry]').find(":selected").data('code');
		oInputVat.val(sLanguageCode);
	}
}

function initDropzone()
{
	if($('.uploadContainer').length)
	{
		var oUploadContainer = $('.uploadContainer');
		var oInpuFilename    = oUploadContainer.parents('.control-group').find('.inputFilename');
		var oImageUpload     = oUploadContainer.find('.imageUpload');
		var oVatRow          = $('.vatRow');
		var oUploadLoader    = oUploadContainer.find('.uploadLoader');
		var oUploadResult    = oUploadContainer.find('.uploadResult');

		// Dropzone
		if(!oImageUpload.hasClass('dz-clickable'))
		{
			oImageUpload.dropzone({
				url: "/index.cfm/content/ajax/upload/content",
				clickable: true,
				success: function(file,oData)
				{
					if(oData.errorType == '')
					{

						oInpuFilename.val(sStaticContentURL + tenantId + '/content/' + encodeURIComponent(oData.fileName));
						oUploadLoader.toggleClass('hide');
						oUploadResult.find('.filename').text(oData.fileName);
						oUploadResult.toggleClass('hide');
						oVatRow.toggleClass('hide');
					}
					else
					{
						oImageUpload.toggleClass('hide');
						oUploadLoader.toggleClass('hide');

						// show error message
						showAlert('error', oData.errorMessage, oData.errorUnhandled);
					}

				},
				addedfile: function()
				{
					oImageUpload.toggleClass('hide');
					oUploadLoader.toggleClass('hide');
				}
			});
		}

		$('.register').on('click','.removeUpload', function()
		{
			oImageUpload.toggleClass('hide');
			oInpuFilename.val('');
			oUploadResult.toggleClass('hide');
			oVatRow.toggleClass('hide');
		});
	}
}

function initGender()
{
	//select first gender when none is selected on load
	if (!$('.radio input[name^=inputGender]:checked').val())
	{
		var oFirstRadio = $('.radio input[name^=inputGender]:first');
		oFirstRadio.prop("checked", true);
		switchGender(oFirstRadio);
	}
}

function mailRegistrationData(frmRegister)
{
	// Clear previous errors
	clearErrors();

	// Disable registration button
	$(el('btnMailRegistrationData')).prop('disabled',true);

	//validate form
	var bValid = validateForm(frmRegister);

	if(bValid)
	{
		var sParams = getValues($('#frmRegister'));
		var oCall = callAjax("mailRegistrationData", sParams, "post", "/index.cfm/customer/ajax/mailRegistrationData");

		// process feedback
		oCall.success(function(oData)
		{
			if(oData.errorType == '')
			{
				if(typeof oData.html !== "undefined" && oData.html !== "")
				{
					$('.register').replaceWith(oData.html);

					ciResponsive.process();
				}
				else
				{
					$('.register').html('<div class="requestFeedback">'+ tRegisterDataMailed +'</div>');
				}
			}
			else
			{
				// show error message
				showAlert('error', oData.errorMessage, oData.errorUnhandled);
				$(el('btnMailRegistrationData')).prop('disabled',false);
			}
		});
	}
	else
	{
		$(el('btnMailRegistrationData')).prop('disabled',false);
	}
}

function toggleNameOrCompanyRequired()
{
	if($('.inputCompany').val() == '' || $('.inputCompany').parents('.control-group').hasClass('hide'))
	{
		$('.inputFirstName, .inputLastName').prop('required', 'required');
		$('.inputCompany').removeAttr('required');
	}
	else
	{
		$('.inputFirstName, .inputLastName').removeAttr('required');
		$('.inputCompany').prop('required', 'required');
	}
}

function validateRegister(frmRegister,bNeedConfirmation)
{
	// Clear previous errors
	clearErrors();

	// Disable button
	$(el('btnRegister')).prop('disabled',true);

	// Validate form
	var bValid = validateForm(frmRegister);

	if(bValid)
	{
		var sParams = getValues($('#frmRegister'));
		if(bNeedConfirmation){
			sParams += '&needConfirmation=true';
		}
		var oCall = callAjax("register", sParams, "post");

		// process feedback
		oCall.success(function(oData)
		{
			if(oData.errorType == '')
			{
				if(bNeedConfirmation){
					$('.register').html('<div class="requestFeedback">'+ tRegisterDataMailed +'</div>');
					setTimeout(function(){
						window.location = '/' + sCurrentLanguageCode
					},2000);
				}
				else{
					var urlParams = getValues($('#frmRegister'));
					var sData = getUrlParam(urlParams, 'edtFirstName') + ' ' + getUrlParam(urlParams, 'edtLastName') + ' - ' + getUrlParam(urlParams, 'edtEmail');
					var bLendout = getUrlParam(window.location, 'lendout');
					$(document).trigger("register", [sData]);

					// Register successful
					showAlert('warning', tRegistered, false);
					setTimeout(function()
					{
						if(typeof sRedirectSuccess !== 'undefined')
						{
							window.location = sRedirectSuccess;
						}
						else if(typeof bViewOnly !== 'undefined' && bViewOnly && typeof sRedirectSelf !== 'undefined' )
						{
							window.location = sRedirectSelf;
						}
						else if(typeof bLendout !== 'undefined' && bLendout && bLendout !== '')
						{
							window.location = '/product/lendout?registered=true'
						}
						else
						{
							window.location = '/' + sCurrentLanguageCode + '/transaction'
						}
					},2000);
				}
			}
			else
			{
				// show error message
				inlineAlert('error', oData.errorMessage, oData.errorUnhandled, $(el('btnRegister')));
				$(el('btnRegister')).prop('disabled',false);
			}
		});
	}
	else
	{
		$('html, body').animate({
		    scrollTop: ($('.error').first().offset().top-200)
		},500);
		$(el('btnRegister')).prop('disabled',false);
	}
}

function switchGender(elem)
{
	elem.each(function(index,element){
		$(element).closest($('.control-group')).siblings('.control-group').find('select[name="inputTitle"]').hide();
		var idGender = $(element).val();
		$(element).closest($('.control-group')).siblings('.control-group').find('#gender'+idGender).show();
		$(element).closest($('.control-group')).siblings('.control-group').find('.gender'+idGender).show();
	});
}

function switchGenderFromTitle(genderId)
{
	$('.radio input[name^=inputGender][value="' + genderId + '"]').prop("checked", true);
}

//Javascript code to show the VAT field when company is filled in
function hideOrShowB2C(){
	var myInput = document.getElementById("inputCompanyFieldIdB2C");
	if (myInput && myInput.value) {
		document.getElementById("inputVATFieldIdB2C").classList.remove('hide');
	} else {
		document.getElementById("inputVATFieldIdB2C").classList.add('hide');
	}
}

//Javascript code to show the VAT field when company is filled in
function hideOrShowB2B(){
	var myInput = document.getElementById("inputCompanyFieldIdB2B");
	if (myInput && myInput.value) {
		document.getElementById("inputVATFieldIdB2B").classList.remove('hide');
	} else {
		document.getElementById("inputVATFieldIdB2B").classList.add('hide');
	}
}
